import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import {
  BORDER,
  COLOR_GREY_12,
  COLOR_GREY_2,
  COLOR_GREY_3,
  COLOR_GREY_5,
  COLOR_WHITE,
} from "shared/theme/colors";

export const StyledButton = styled(Button, {
  shouldForwardProp: (propName) =>
    !["isSmallButton", "isActive"].includes(propName),
})<{
  isActive: boolean;
  isSmallButton: boolean;
}>`
  border-radius: 0.5rem;
  font-weight: ${({ isSmallButton }) => (isSmallButton ? 400 : 500)};
  font-size: 0.875rem;
  text-transform: initial;
  padding: ${({ isSmallButton }) =>
    isSmallButton ? "4px 8px" : "0.5rem 1rem"};
  box-sizing: border-box;
  border: ${({ isSmallButton, isActive }) =>
    isSmallButton
      ? BORDER(1, isActive ? COLOR_GREY_12 : COLOR_GREY_5)
      : "none"};

  background-color: ${({ isActive }) =>
    isActive ? COLOR_GREY_3 : COLOR_WHITE};

  &.MuiButton-root {
    &:hover {
      background-color: ${COLOR_GREY_2};
    }

    & .MuiButton-endIcon {
      margin-left: ${({ isSmallButton }) => (isSmallButton ? "4px" : "8px")};
    }

    &:disabled {
      span {
        color: ${COLOR_GREY_5};
      }

      svg > path {
        fill: ${COLOR_GREY_5};
      }
    }
  }
`;
